import { render, staticRenderFns } from "./NotificationStep.vue?vue&type=template&id=22e6106c&"
import script from "./NotificationStep.vue?vue&type=script&lang=js&"
export * from "./NotificationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports